import {
  AccountClient,
  GET_ALL_TECHS_NEW,
  TicketClient,
  GET_ALL_TECH_GROUP,
  GET_PERSONALIZATION_BY_NAME,
  getPersonalization,
  GET_FIELD,
  GET_ALL_WORK_STATUSES
} from '@nile/graphql';
import nanoid from 'nanoid';
import { ALL_MODULES, DEFAULT_FIELDS_BY_COLUMN_NAME } from '@nile/components';

const getAllTechnicianGroups = async () => {
  const response = await AccountClient.query({ query: GET_ALL_TECH_GROUP });
  return new Promise((resolve) => {
    let allGroups = [];
    if (response?.data?.getTechnicianGroups) {
      allGroups = response.data.getTechnicianGroups.map((el) => ({
        ...el,
        id: el.groupId,
        value: el.name
      }));
    }
    resolve(allGroups);
  });
};
const getAllTechnicians = async () => {
  const allTechResponse = await AccountClient.query({
    query: GET_ALL_TECHS_NEW,
    variables: {
      input: {
        listInfo: {
          sort: {
            attribute: 'name',
            order: 'ASC'
          }
        }
      }
    }
  });
  return new Promise((resolve) => {
    let allTechs = [];
    if (allTechResponse?.data?.getTechnicianList?.userList) {
      allTechs = allTechResponse.data.getTechnicianList.userList.map(
        (tech) => ({
          ...tech,
          id: tech.userId,
          value: tech.name
        })
      );
    }
    resolve(allTechs);
  });
};
const getAllPriorities = async () => {
  const response = await AccountClient.query({
    query: GET_FIELD,
    variables: {
      input: {
        module: ALL_MODULES.ticket,
        columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.PRIORITY
      }
    }
  });

  return new Promise((resolve) => {
    let allPriorities = [];
    const fldOptions =
      response?.data?.getField?.options ||
      response?.data?.getField?.fieldOptions;
    if (fldOptions) {
      allPriorities = fldOptions?.map((el) => ({
        ...el,
        name: el?.value,
        id: el.id,
        value: el.value
      }));
    }
    resolve(allPriorities);
  });
};
const getAllStatus = async () => {
  const response = await AccountClient.query({
    query: GET_FIELD,
    fetchPolicy: 'network-only',
    variables: {
      input: {
        module: ALL_MODULES.ticket,
        columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.STATUS
      }
    }
  });

  return new Promise((resolve) => {
    let allStatus = [];
    const fldOptions =
      response?.data?.getField?.options ||
      response?.data?.getField?.fieldOptions;
    if (fldOptions) {
      allStatus = fldOptions?.map((el) => ({
        id: el?.id,
        name: el?.value,
        description: el?.details?.description
      }));
    }
    resolve(allStatus);
  });
};

const getAllWorkStatus = async () => {
  const response = await TicketClient.query({
    query: GET_ALL_WORK_STATUSES,
    fetchPolicy: 'network-only'
  });

  return new Promise((resolve) => {
    let allStatus = [];
    if (response.data?.getWorkStatuses) {
      allStatus = response.data?.getWorkStatuses.map((el) => ({
        ...el,
        id: el?.name,
        label: el?.name,
        value: el?.name
      }));
    }
    resolve(allStatus);
  });
};

const getColumnOrder = async (name, userId, category) => {
  console.log('getColumnOrder called');
  const response = await AccountClient.query({
    query: GET_PERSONALIZATION_BY_NAME,
    variables: {
      userId: userId,
      category: category || 'TicketKanbanView',
      name: name
    },
    fetchPolicy: 'network-only'
  });
  return new Promise((resolve) => {
    let columnOrder = [];
    const getPersonalizationByCategoryAndName =
      response?.data?.getPersonalizationByCategoryAndName;
    if (
      getPersonalizationByCategoryAndName &&
      getPersonalizationByCategoryAndName?.value
    ) {
      columnOrder = JSON.parse(getPersonalizationByCategoryAndName?.value);
    }
    resolve(columnOrder);
  });
};
const getPinnedColumnData = async (userId, category) => {
  const pinnedColumnData = await getPersonalization({
    userId: userId,
    category: category || 'TicketKanbanView',
    name: 'kanbanPinnedColumns'
  });
  return new Promise((resolve) => {
    resolve(pinnedColumnData);
  });
};
const getAllPrioritiesTask = async () => {
  const response = await AccountClient.query({
    query: GET_FIELD,
    variables: {
      input: {
        module: ALL_MODULES.task,
        columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.PRIORITY
      }
    }
  });

  return new Promise((resolve) => {
    let allPriorities = [];
    const fldOptions =
      response?.data?.getField?.options ||
      response?.data?.getField?.fieldOptions;
    if (fldOptions) {
      allPriorities = fldOptions?.map((el) => ({
        ...el,
        name: el?.value,
        id: el.id,
        value: el.value
      }));
    }
    resolve(allPriorities);
  });
};

const Queries = {
  getAllTechnicianGroups,
  getAllTechnicians,
  getAllPriorities,
  getAllStatus,
  getColumnOrder,
  getPinnedColumnData,
  getAllWorkStatus,
  getAllPrioritiesTask
};

export default Queries;
